import React, { useEffect, useRef, useState } from 'react';
import { Card, Col, Row, Button, Spin, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getAllAds } from '../../../slices/ads/thunk';
import NotificationImage from '../../../assets/images/notification_image.png';
import './liveAds.scss';
import NoResults from '../../Components/NoResults/NoResults';
import { getVerifiedStatus } from '../../../Services/LocalStorageService';
import Log from '../../../Services/Log';
import Filter_Sort from '../../Components/Filter_Sort/Filter_Sort';
import useNotification from 'antd/es/notification/useNotification';
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import DateService from '../../../Services/DateService';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getStatus } from '../../../Services/AdsStatusService';
import { getDashboard } from '../../../slices/dashboard/thunk';
import ProfileNotVerifiedPopup from '../../../Common/profileNotVerifiedPopup/ProfileNotVerifiedPopup';
import { toast } from 'react-toastify';


const LiveAds = ({ version, data, getStatusData, mobLiveAds }) => {
    let adminVerificationStatus = useSelector((state) => state.Dashboard?.adminVerificationStatus);
    const filterBox = useRef(null);
    const [hasData, setHasData] = useState(false);
    const location = useLocation();
    const [noResultsUi, setNoResultsUi] = useState(false);
    const navigate = useNavigate();
    const [ads, setAds] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState(false);
    const [errorVerificationModal, setErrorVerificationModal] = useState(false);
    let NoVisibleAds = 2;
    const dispatch = useDispatch();
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const limit = 6;
    const [featureActive, setFeatureActive] = useState(false);
    const [filter, setFilter] = useState({
        filterOption: '',
        filterValue: ''
    })
    const [filterActive, setFilterActive] = useState(true);
    const [activeAds, setActiveAds] = useState([]);
    const [dashboardActiveAds, setDashboardActiveAds] = useState([]);
    const dashboard = useSelector((state) => state.Dashboard);
    const [initialLoading, setInitialLoading] = useState(true);
    const [sort, setSort] = useState({
        value: ''
    })

    const [profileNotVerifiedModal, setProfileNotVerifiedModal] = useState(false);
    if (version === "Detail") {
        NoVisibleAds = 100;
    }

    useEffect(() => {
        if (getStatusData) {
            getStatusData('active');
        }
    }, [getStatusData]);

    useEffect(() => {
        setLoading(true)// Set loading to true if data is not available
        if (data && data.length > 0) {
            setActiveAds(data);
            setTotal(data.length);
            setLoading(false)
        } else {
            dispatch(getAllAds({ status: 'all', page: page, limit: limit }));
            setLoading(false)
        }
    }, [data, dispatch]);

    useEffect(() => {
        if (!allAds.loading) {
            if (!filter.filterOption && !filter.filterValue) {
                dispatch(getAllAds({ status: 'all', page: page, limit: limit }));
            }
            else {
                let dataToSend = buildDataToSend('filter', filter.filterOption, filter.filterValue);
                dispatch(getAllAds({ status: dataToSend, page: page, limit: limit }));
            }
        }
    }, [page])

    const allAds = useSelector((state) => state.AllAds);

    useEffect(() => {
        if (allAds?.data) {
            console.log('allAds', allAds?.data)
        }
        setTotal(allAds?.ads?.length);
        setAds((prev) => {
            if (page === 1) {
                return allAds.ads;
            } else {
                let filteredAds = allAds.ads.filter((ad) =>
                    !prev.some((prevAd) => prevAd.ad_id === ad.ad_id)
                );
                return allAds.ads.length > 0 ? [...prev, ...filteredAds] : prev;
            }
        });

    }, [allAds]);

    useEffect(() => {
        if (allAds.length < limit) {
            setHasMore(false);
        }
        if (ads.length) {
            setHasData(true)

        }

        if (filter.filterValue && hasData && ads?.length === 0 && total === 0) {
            setNoResultsUi(true)
        }
        else {
            setNoResultsUi(false)
        }

    }, [ads]);


    const handleCancel = (id) => {
        setErrorVerificationModal(false)
    };
    const fetchMoreData = () => {
        if (!allAds?.loading || !loading) {
            setPage(prevPage => prevPage + 1)
        }
        if (currentLocation === '/dashboard') {
            setPage(1)
            setAds([])
        }
    }
    let feature = false;
    const featureStatus = (status) => {
        setFeatureActive(status)
    }
    useEffect(() => {
        if (!allAds.loading) {
            let dataToSend = buildDataToSend('filter', filter.filterOption, filter.filterValue);
            setPage(1)
            dispatch(getAllAds({ status: dataToSend, page: page, limit: limit }));
            setNoResultsUi(false)
        }

    }, [filter])

    function buildDataToSend(feature, option, value) {
        if (feature === 'filter') {
            if (option === 'transaction_status') {
                return {
                    'filter': {
                        'transaction_status': value,
                    }
                };
            } else if (option === 'status') {
                if (value === 'pending') {
                    return {
                        'filter': {
                            'status': value,
                            'transaction_status': 'completed'
                        }
                    };
                }
                else {
                    return {
                        'filter': {
                            'status': value,
                        }
                    };
                }
            }
        } else {
            return {
                'sort': {
                    sortOption: value
                }
            };
        }
    }
    useEffect(() => {
        if (dashboard?.data?.ads) {

            setDashboardActiveAds(dashboard?.data?.ads)
        }
    }, [dashboard])
    // const handleScroll = () => {
    //     console.log('Scrolled!' , allAds.loading);
    // };
    // window.addEventListener('scroll', handleScroll);


    let currentLocation = location.pathname;
    // Status 

    useEffect(() => {
        dispatch(getDashboard());
        const handleClickOutside = (event) => {
            if (filterBox.current && !filterBox.current.contains(event.target)) {
                setFilterActive(prev => !prev);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    useEffect(() => {
        if (adminVerificationStatus) {
            setStatus(adminVerificationStatus)
        }
    }, [adminVerificationStatus])

    useEffect(() => {
        if (!allAds.loading) {
            setInitialLoading(false);
        }
    }, [allAds.loading]);

    useEffect(() => {
        console.log('profileNotVerifiedModal', profileNotVerifiedModal)
    }, [profileNotVerifiedModal])


    return (
        <React.Fragment >
            <div className="live_ads_bod parent_wrap">
                {
                    (allAds.loading && initialLoading) && (
                        // <ShimmerSimpleGallery card imageHeight={180} caption className="basic_shimmer_holder" />
                        <div className="spinner center" key={0}>
                            <Spin />
                        </div>
                    )
                }


                <InfiniteScroll
                    dataLength={ads?.length}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    loader={
                        allAds.loading && (
                            <div className="spinner center" key={0}>
                                <Spin />
                            </div>
                        )
                    }


                >
                    <Col lg={24} xs={24} style={{ marginTop: 0 }}>

                        <section className={`live_ads block ${version === 'Detail' ? 'detailVersion' : 'defaultVersion'}`} style={{ width: "100%" }}>
                            {/*  live ads title added  */}
                            {/* {dashboardActiveAds.length !== 0 && currentLocation === '/dashboard' && (
                                <h4 className="text_md mb-0" style={{ marginBottom: version === 'Detail' ? null : "1em", fontWeight: '500' }}>
                                    Live Ads
                                </h4>
                            )} */}

                            <Card>
                                {(currentLocation === '/dashboard' && !dashboardActiveAds?.length > 0) && (
                                    <NoResults
                                        type={'ad'}
                                        title={'Create Your Ad'}
                                        description={'Creative designs catch the eye, so make sure yours stands out!'}>
                                        <Button className="wide mb" type='primary'
                                            onClick={() => {
                                                // if (!status) {
                                                //     setProfileNotVerifiedModal(prev => !prev)
                                                // } else {
                                                //     navigate('/live-ads/new-ads');
                                                // }
                                                navigate('/live-ads/new-ads');
                                            }}>Create Ad</Button>
                                    </NoResults>
                                )}


                                {
                                    <div className="button_wrap" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        {version === 'Detail' ? (
                                            <>
                                                <h4 className="text_md mb-0" style={{ marginBottom: version === 'Detail' ? null : "1em", fontWeight: '500' }}>
                                                    {version === 'Detail' ? 'All Ads' : 'Live Ads'}
                                                </h4>
                                                {location.pathname !== '/dashboard' && (
                                                    <div className="filter_parent" ref={filterBox} style={{ display: 'inline-flex' }}>
                                                        <Filter_Sort
                                                            featureStatus={featureStatus}
                                                            filterDropdownStatus={filterActive}
                                                            filterCatch={(filterType, key) => {
                                                                setPage(1);
                                                                setFilter({
                                                                    filterOption: filterType,
                                                                    filterValue: key,
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                                <Link type='primary' to="/live-ads/new-ads">
                                                    <Button type='primary'>Create Ad</Button>
                                                </Link>
                                            </>
                                        ) : null}
                                    </div>
                                }
                                {
                                    dashboardActiveAds.length > 0 && currentLocation === '/dashboard' && (
                                        <h4 className="text_md" style={{ marginBottom: '1em' }}>
                                            {dashboardActiveAds.length > 1 ? 'Active Ads' : 'Active Ad'}
                                        </h4>
                                    )
                                }
                                <Row className={`live_ads_list`} gutter={[35, 25]}>
                                    {(ads?.length || dashboardActiveAds.length !== 0) ? (
                                        <>
                                            {currentLocation === '/dashboard' &&
                                                dashboardActiveAds?.map((item, index) => (

                                                    <Col xs={24} lg={12} key={index} className='live_ads_cnt'>
                                                        <div className='red_shadow' >
                                                            <Link to={`/live-ads/${item.ad_id}`} className={`${!status && 'inactive_link'}`} >
                                                                <figure style={{ marginBottom: "0" }} className='banner_ratio'>
                                                                    {item?.ad_images?.map((img, imgIndex) => (
                                                                        <img key={imgIndex} src={img.thumbnail} alt={`Image ${imgIndex}`} className='img_full cover' loading="lazy" />
                                                                    ))}
                                                                </figure>
                                                            </Link>
                                                            <div className='ad_content'>
                                                                {version === "Detail" ? (
                                                                    <div className="cnt">
                                                                        <div className="bottom_wrap">
                                                                            <div className="top">
                                                                                <span>
                                                                                    <span className='semibold'>Created Date :</span>&nbsp;
                                                                                    <span>{DateService.formatDateCustom(item?.created_at)} </span>
                                                                                </span>
                                                                            </div>
                                                                            <div className="bottom">
                                                                                <span>
                                                                                    <span>Views :</span>&nbsp;
                                                                                    <span>{item?.total_views}</span>
                                                                                </span>
                                                                                {item?.transaction_status !== "completed" && (
                                                                                    <Button className="wide text_white" type='primary'
                                                                                        onClick={() => {
                                                                                            navigate('/live-ads/new-ads',
                                                                                                { state: { adItem: item, initiatePaymentStatus: true } });
                                                                                        }}>
                                                                                        <span className='text_white'>Continue Payment</span>
                                                                                    </Button>
                                                                                )}
                                                                                {item.contacts_accessed && (
                                                                                    <span className='date'>
                                                                                        <span>Contacts Accessed: <span className="text_red" style={{ fontWeight: "bold" }}>{item.contactsAccessed}</span></span>
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                            <div className="bottom">
                                                                                <span>
                                                                                    <span>Clicks :</span>&nbsp;
                                                                                    <span>{item?.total_clicks}</span>
                                                                                </span>
                                                                                <span className='date'>
                                                                                    <span>Status : </span>
                                                                                    {getStatus(item?.status, item?.transaction_status)}
                                                                                    {/* {(() => {
                                                                                    if (item?.status === 'active' && item?.transaction_status === 'completed') {
                                                                                        return <span className='text_green semibold' style={{ textTransform: "capitalize" }}>Active</span>;
                                                                                    } else if (item?.status === 'pending' && item?.transaction_status === 'pending') {
                                                                                        return <span className='text_yellow semibold' style={{ textTransform: "capitalize" }}>Draft</span>;
                                                                                    } else if (item?.status === 'completed' && item?.transaction_status === 'pending') {
                                                                                        return <span className='text_red semibold' style={{ textTransform: "capitalize" }}>Make Payment</span>;
                                                                                    } else if (item?.status === 'pending' && item?.transaction_status === 'completed') {
                                                                                        return <span className='text_yellow semibold' style={{ textTransform: "capitalize" }}>In Review</span>;
                                                                                    } else if (item?.status === 'inactive') {
                                                                                        return <span className='text_gray semibold' style={{ textTransform: "capitalize" }}>Inactive</span>;
                                                                                    }
                                                                                    else if (item?.status === 'rejected' && item?.transaction_status === 'completed') {
                                                                                        return <span className='text_gray semibold' style={{ textTransform: "capitalize" }}>Rejected</span>;
                                                                                    } else {
                                                                                        return <span className='text_yellow semibold' style={{ textTransform: "capitalize" }}>Pending</span>;
                                                                                    }
                                                                                })()} */}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="cnt default_live_ads">
                                                                        <span className='md'>
                                                                            <span>Views :</span>&nbsp;
                                                                            <span>{item.total_views}</span>
                                                                        </span>
                                                                        <span className='md'>
                                                                            <span>Clicks :</span>&nbsp;
                                                                            <span>{item.total_clicks}</span>
                                                                        </span>
                                                                        <span className='date text_red md' style={{ fontWeight: 400 }}>
                                                                            {getStatus(item.status)}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                ))}
                                            {/* {
                                                currentLocation === '/dashboard' && (
                                                    dashboardActiveAds?.length === 0 && (
                                                        <NoResults
                                                            type={'ad'}
                                                            title={'Create Your Ad'}
                                                            description={'Creative designs catch the eye, so make sure yours stands out!'}
                                                        >
                                                            <Button className="wide mb" type='primary'
                                                                onClick={() => {
                                                                    // if (!status) {
                                                                    //     setProfileNotVerifiedModal(prev => !prev)
                                                                    // } else {
                                                                    //     navigate('/live-ads/new-ads');
                                                                    // }
                                                                    navigate('/live-ads/new-ads');
                                                                }}>Create Ad</Button>
                                                        </NoResults>
                                                    )
                                                )
                                            } */}
                                            {currentLocation !== '/dashboard' && (
                                                <>
                                                    {ads?.map((item, index) => (
                                                        <Col xs={24} lg={12} key={index} className='live_ads_cnt '>
                                                            <div className="red_shadow" style={{ height: "100%" }}>
                                                                <Link to={`/live-ads/${item.ad_id}`} className={`${!status && 'inactive_link'}`}>
                                                                    <figure style={{ marginBottom: "0" }} className='banner_ratio '>
                                                                        {item?.ad_images?.map((img, imgIndex) => (
                                                                            <img key={imgIndex} src={img.thumbnail} alt={`Image ${imgIndex}`} className='img_full cover' loading="lazy" />
                                                                        ))}
                                                                    </figure>
                                                                </Link>
                                                                <div className='ad_content'>
                                                                    {version === "Detail" ? (
                                                                        <div className="cnt">
                                                                            <div className="bottom_wrap">
                                                                                <div className="top">
                                                                                    <span>
                                                                                        <span className='semibold'>Created Date :</span>&nbsp;
                                                                                        <span>{DateService.formatDateCustom(item?.created_at)}</span>
                                                                                    </span>
                                                                                    <span><strong className='text_red'>Ad Id</strong> : {item?.ad_id}</span>
                                                                                </div>
                                                                                <div className="bottom">
                                                                                    <span>
                                                                                        <span>Views :</span>&nbsp;
                                                                                        <span>{(item?.status !== 'active' && item?.total_views === 0) ? 'NA' : item?.total_views}</span>
                                                                                    </span>

                                                                                    {item?.transaction_status !== "completed" && (
                                                                                        <Button className="wide text_white" type='primary' onClick={() => {
                                                                                            navigate('/live-ads/new-ads', { state: { adItem: item, initiatePaymentStatus: true } });
                                                                                        }}>
                                                                                            <span className='text_white'>Continue Payment</span>
                                                                                        </Button>
                                                                                    )}

                                                                                    {item.contacts_accessed && (
                                                                                        <span className='date'>
                                                                                            <span>Contacts Accessed: <span className="text_red" style={{ fontWeight: "bold" }}>{item.contactsAccessed}</span></span>
                                                                                        </span>
                                                                                    )}

                                                                                </div>
                                                                                <div className="bottom">
                                                                                    <span>
                                                                                        <span>Clicks :</span>&nbsp;
                                                                                        <span>{(item?.status !== 'active' && item?.total_clicks === 0) ? 'NA' : item?.total_clicks}</span>
                                                                                    </span>
                                                                                    <span className='date'>
                                                                                        <span>Status : </span>
                                                                                        {getStatus(item?.status, item?.transaction_status)}
                                                                                    </span>
                                                                                    <Link to={`/live-ads/${item.ad_id}`} className='btn_blue text_sm text_blue'>View Details</Link>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="cnt default_live_ads">
                                                                            <span className='md'>
                                                                                <span>Views :</span>&nbsp;
                                                                                <span>{item.total_views}</span>
                                                                            </span>
                                                                            <span className='md'>
                                                                                <span>Clicks :</span>&nbsp;
                                                                                <span>{item.total_clicks}</span>
                                                                            </span>
                                                                            <span className='date text_red md' style={{ fontWeight: 400 }}>
                                                                                {item.status}
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                    {
                                                                        item?.status === "rejected" && (
                                                                            <div className="rejected_cnt">
                                                                                <div>
                                                                                    {item?.warning?.title && <h2 className="text_lg text_red">{item?.warning?.title}</h2>}
                                                                                    {item?.warning?.description && <p className='md text_red'>{item?.warning?.description}</p>}
                                                                                </div>
                                                                                <Button className="cmn text_white" type='primary' onClick={() => {
                                                                                    navigate('/live-ads/new-ads', { state: { adItem: item, initiatePaymentStatus: true } });
                                                                                }}>
                                                                                    <span className='text_white md'>Edit Ad</span>
                                                                                </Button>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </>
                                            )}



                                        </>
                                    ) : (
                                        (!allAds.loading && !noResultsUi && currentLocation !== '/dashboard')
                                            ? (
                                                <NoResults
                                                    type={'ad'}
                                                    title={'Create Your Ad'}
                                                    description={'Creative designs catch the eye, so make sure yours stands out!'}>
                                                    <Button className="wide mb" type='primary'
                                                        onClick={() => {
                                                            // if (!status) {
                                                            //     setProfileNotVerifiedModal(prev => !prev)
                                                            // } else {
                                                            //     navigate('/live-ads/new-ads');
                                                            // }
                                                            navigate('/live-ads/new-ads');
                                                        }}>Create Ad</Button>
                                                </NoResults>
                                            ) : null

                                    )}

                                </Row>
                                {
                                    noResultsUi && <div className="no_result_cnt">
                                        <h2 className='text_red text_lg'>No Results Found </h2>
                                    </div>
                                }
                                <ProfileNotVerifiedPopup status={profileNotVerifiedModal} />
                            </Card>
                        </section>
                    </Col>
                </InfiniteScroll>
            </div>
        </React.Fragment>
    );
};

export default LiveAds;
